enum PlatformServiceUnitEnum {
  TONN = "TONN", //price per ton
  KG = "KG", //price per kg
  ORDRE = "ORDRE", //price per order
  PROSENT = "PROSENT", //procent of total price
}

export default PlatformServiceUnitEnum;
